module.exports = __webpack_public_path__ + "img/BRD.879fc2f3.svg";